import * as _ from 'lodash'

const SUPER_NUMERALS = ['\u2070', '\u00B9', '\u00B2', '\u00B3', '\u2074', '\u2075', '\u2076', '\u2077', '\u2078', '\u2079']
const SUB_NUMERALS = ['\u2080', '\u2081', '\u2082', '\u2083', '\u2084', '\u2085', '\u2086', '\u2087', '\u2088', '\u2089']

const SUPER_SUB_RE = new RegExp(SUPER_NUMERALS.concat(SUB_NUMERALS).join('|'), 'gi')

export function replaceSupers(s) {
	return s.replace(SUPER_SUB_RE, (match) => {
		let i = _.indexOf(SUPER_NUMERALS, match)
		if (i == -1) {
			i = _.indexOf(SUB_NUMERALS, match)
		}
		if (i != -1) {
			return i + ''
		} else {
			return match
		}
	})
}

export function sanitize(text) {
	return replaceSupers(_.deburr(text.trim()))
}

// Pads any / or | characters surrounded by non-whitespace
// with thinspace to improve line wrapping behavior
export function padSpecialChars(str) {
	return str.replace(/([^\s])([|/])/g, '$1\u200B$2')
		.replace(/([|/])([^\s])/g, '$1\u200B$2')
}

export function safeId(id: string) {
	return id.replace(/\s+/ig, '')
}
